﻿import { type App, inject } from 'vue';

interface IInterval {
    setInterval(
        handler: TimerHandler,
        timeout?: number
    ): void;

    clearInterval(): void;
}

export class Interval implements IInterval {
    private intervalId: number | null;

    constructor() {
        this.intervalId = null;
    }

    setInterval(
        handler: TimerHandler,
        timeout?: number
    ) {
        this.clearInterval();
        this.intervalId = window.setInterval(handler, timeout);
    }

    clearInterval() {
        if (this.intervalId !== null) {
            window.clearInterval(this.intervalId);
            this.intervalId = null;
        }
    }
}

export class IntervalState {
    reloadPrompt: IInterval;
    statusCheck: IInterval;

    constructor() {
        this.reloadPrompt = new Interval();
        this.statusCheck = new Interval();
    }

    static inject(): IntervalState | undefined {
        return inject<IntervalState>('interval-state');
    }

    static provide(app: App<Element>) {
        app.provide<IntervalState>('interval-state', new IntervalState());
    }
}
